import Button, { ButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';

const PREFIX = 'ProgressButton';

const classes = {
  wrapper: `${PREFIX}-wrapper`,
  buttonProgress: `${PREFIX}-buttonProgress`,
};

const Root = styled('div')(() => ({
  [`&.${classes.wrapper}`]: {
    position: 'relative',
  },

  [`& .${classes.buttonProgress}`]: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

interface ProgressButtonProps {
  loading?: boolean;
  isLabel?: boolean
}

const ProgressButton = ({ loading, isLabel, ...buttonProps }: ButtonProps & ProgressButtonProps) => {
  const updatedProps = {
    ...buttonProps,
    disabled: loading ? true : buttonProps.disabled,
  };

  return (
    <Root className={classes.wrapper}>
      {/* !Type issue - component prop not part of the ButtonProps type */}
      <Button component={isLabel ? 'label' : undefined} {...updatedProps as any} />
      {loading && <CircularProgress size={24} className={classes.buttonProgress} color="secondary" />}
    </Root>
  );
};

export default ProgressButton;
